import riot from 'riot';
import observable from 'static/script/app/ui/checkout2/context/observable';
import modal from 'static/script/app/ui/checkout2/context/modal';
import payment from 'static/script/app/ui/checkout2/context/payment';
import shipping from 'static/script/app/ui/checkout2/context/shipping';

let context = {
    observable: observable,
    modal: modal,
    payment: payment,
    shipping: shipping
};

context.init = function(model, featureToggles, pageName) {
    riot.mount('checkout-payment', {
        model: model,
        featureToggles: featureToggles,
        pageName: pageName
    });
};

export default context;
